import styled, { css } from 'styled-components';
import Button from '@carvana/forms/Button';
import BodyTextBlock from '@carvana/showroom-content/TextBlock/Body';
import Select, { SelectLabelDefault } from '@carvana/forms/Select';

import { getMediaQuery } from '@carvana/showroom-theme';
import CaretRight from '../../../../../images/icons/caret-right.svg';

export const StyledContainer = styled.div``;

export const StyledButton = styled(Button)`
  width: 3.5rem;
  height: 3.5rem;
`;

export const StyledIconRightCaret = styled(CaretRight)`
  width: 12px;
  height: 12px;
`;

export const StyledIconLeftCaret = styled(StyledIconRightCaret)`
  transform: rotate(180deg);
`;

export const StyledPagesList = styled.div`
  display: none;

  ${(props) => getMediaQuery(props.theme.breakpoint.md)} {
    display: flex;
  }
`;

// Custom Select and alements within it
export const StyledPagesSelect = styled(Select)`
  height: 34px;

  ${(props) => getMediaQuery(props.theme.breakpoint.md)} {
    display: none;
  }
`;

export const StyledPagesSelectLabel = styled(SelectLabelDefault)`
  label {
    visibility: hidden;
    margin: 0px;
    height: 0px;
  }

  span {
    color: ${({ theme }) => theme.carvana.blue.dark} !important;
    text-transform: uppercase;
  }

  + div {
    height: 18px;
  }
`;


// Page Number Styles
const defaultPageNumber = css`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 2px;
  font-size: 0.875rem;
  cursor: pointer;
  background: transparent;
`;

const activePageNumber = css`
  ${defaultPageNumber};
  background-color: ${({ theme }) => theme.carvana.gray.background};
  border: 1px solid ${({ theme }) => theme.carvana.blue.primary};
`;

export const StyledPageNumber = styled.button`
  ${(props) => (props.active ? activePageNumber : defaultPageNumber)}

  margin: 0 4px;
`;

export const StyledPageNumberText = styled(BodyTextBlock.Title)``;
